import { GET_EBOOKS, ADD_EBOOKS, REMOVE_EBOOKS } from '../actions/ebooks';

const initialState = { list: [] };

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_EBOOKS:
            return { ...state, list: action.data }; // Шинэ датагаар шууд солих

        case ADD_EBOOKS:
            return { ...state, list: [...state.list, ...action.data] }; // Өмнөх дататай нийлүүлж хадгалах
        // return { ...state, list: action.data };
        case REMOVE_EBOOKS:
            return { ...state, list: state.list.filter((book) => book.id !== action.data) };

        default:
            return state;
    }
};

export default [reducer, initialState];
